import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronLeftSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M14.1163 7.46967C13.8234 7.17678 13.3485 7.17678 13.0556 7.46967L9.76271 10.7626C9.0793 11.446 9.0793 12.554 9.76271 13.2374L13.0556 16.5303C13.3485 16.8232 13.8234 16.8232 14.1163 16.5303C14.4092 16.2374 14.4092 15.7626 14.1163 15.4697L10.8234 12.1768C10.7257 12.0791 10.7257 11.9209 10.8234 11.8232L14.1163 8.53033C14.4092 8.23744 14.4092 7.76256 14.1163 7.46967Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftSmall;
